import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { StudentStatsModel } from '@generativ/much-smarter-models';
import { EntryDictionary, CompleteType } from '@generativ/ms-student-types';

import { ExerciseService } from '../../shared/exercise.service';
import { ContentfulService } from '../../../../../shared/contentful.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { SpinnerComponent } from '../../../../../shared/spinner/spinner.component';

@Component({
    selector: 'app-lesson-completed',
    templateUrl: './lesson-completed.component.html',
    styleUrls: ['./lesson-completed.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, SpinnerComponent, AsyncPipe]
})
export class LessonCompletedComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  exercisePerformance: Observable<StudentStatsModel>;
  content: CompleteType;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private exerciseService: ExerciseService,
              private contentfulService: ContentfulService) {
  }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.params.subscribe((params) => {
        if (params['exerciseId']) {
        this.exercisePerformance = this.exerciseService.getScore(params['exerciseId']);
      }
    }));
    this.contentfulService.getStudentEntry(EntryDictionary.Complete.exerciseComplete).then(
      (entry) => {
        this.content = new CompleteType(entry);
      },
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onPersistedRound() {
    const currentExerciseId = localStorage.getItem('currentExerciseId');
    this.subscriptions.add(this.exerciseService.startExercise(+currentExerciseId, true).subscribe(
      () => {
        this.router.navigate([`../persistence`], {relativeTo: this.activatedRoute});
      }
    ));
  }

  onEndExercise() {
    if (this.exerciseService.isLastExercise) {
      this.router.navigate(['../conclude'], {relativeTo: this.activatedRoute});
    } else {
      this.router.navigate(['../']);
    }
  }

}
